/**
 * Placeholder Shown Polyfill
 * 为不支持 :not(:placeholder-shown) 的浏览器提供兼容性支持
 * 特别是iOS Safari
 */

(function() {
  'use strict';

  // 检测浏览器是否支持 :not(:placeholder-shown)
  function supportsPlaceholderShown() {
    try {
      const test = document.createElement('input');
      test.placeholder = 'test';
      const style = document.createElement('style');
      style.textContent = 'input:not(:placeholder-shown) { color: red; }';
      document.head.appendChild(style);
      const isSupported = window.getComputedStyle(test).color === 'red';
      document.head.removeChild(style);
      return isSupported;
    } catch (e) {
      return false;
    }
  }

  // 检测是否为iOS Safari
  function isIOSSafari() {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const isSafari = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
    return isIOS && isSafari;
  }

  // 如果浏览器支持且不是iOS Safari，不需要polyfill
  if (supportsPlaceholderShown() && !isIOSSafari()) {
    return;
  }

  // 为所有输入框添加placeholder状态管理
  function initPlaceholderPolyfill() {
    const inputs = document.querySelectorAll('input[placeholder], textarea[placeholder]');
    
    inputs.forEach(input => {
      // 初始化状态
      updatePlaceholderState(input);
      
      // 监听输入事件
      input.addEventListener('input', () => updatePlaceholderState(input));
      input.addEventListener('focus', () => updatePlaceholderState(input));
      input.addEventListener('blur', () => updatePlaceholderState(input));
      
      // 监听属性变化（如果placeholder属性改变）
      if (window.MutationObserver) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'placeholder') {
              updatePlaceholderState(input);
            }
          });
        });
        observer.observe(input, { attributes: true, attributeFilter: ['placeholder'] });
      }
    });
  }

  // 更新placeholder状态
  function updatePlaceholderState(input) {
    const isPlaceholderShown = input.value.length === 0;
    
    // 添加/移除CSS类
    if (isPlaceholderShown) {
      input.classList.remove('not-placeholder-shown');
      input.classList.add('placeholder-shown');
    } else {
      input.classList.add('not-placeholder-shown');
      input.classList.remove('placeholder-shown');
    }
    
    // 同时更新对应的label状态
    const label = input.parentElement ? input.parentElement.querySelector('.component-text-input__label') : null;
    if (label) {
      if (isPlaceholderShown) {
        label.classList.remove('not-placeholder-shown');
      } else {
        label.classList.add('not-placeholder-shown');
      }
    }
    
    // 触发自定义事件，让其他组件可以监听
    const event = new CustomEvent('placeholderStateChange', {
      detail: {
        isPlaceholderShown: isPlaceholderShown,
        hasValue: !isPlaceholderShown
      }
    });
    input.dispatchEvent(event);
  }

  // 全局函数，可以在需要时手动触发
  window.PlaceholderPolyfill = {
    init: initPlaceholderPolyfill,
    updateState: updatePlaceholderState,
    isSupported: supportsPlaceholderShown,
    isIOSSafari: isIOSSafari
  };

  // 自动初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPlaceholderPolyfill);
  } else {
    initPlaceholderPolyfill();
  }

  // 延迟再次检查，确保动态内容也被处理
  setTimeout(initPlaceholderPolyfill, 100);
  setTimeout(initPlaceholderPolyfill, 500);
})(); 